import BenzAMRRecorder from "benz-amr-recorder";
import { Howl, Howler } from 'howler';
export const VoiceStatus = {
  PLAY: "play", // 播放
  STOP: "stop", // 停止
  RESUME: "resume", // 继续
  PAUSE: "pause", // 暂停
  ENDED: "ended", // 结束
  AUTOENDED: "autoEnded" // 自动结束
};

let voiceHandler: VoiceHandler | null;
class VoiceHandler {
  id = "";
  url = "";
  voiceAmr: BenzAMRRecorder | null = null;
  howler: any = null;
  options: any;
  type: string;
  constructor(id: string, url: string, options?: any) {
    this.id = id;
    this.url = url;
    this.options = options;
    if (options.type === "opus") {
      this.type = "opus";
      this.initOpus();
    } else {
      this.type = "arm";
      this.init();
    }
  }

  initOpus() {
    this.howler = new Howl({
      src: [this.url],
      format: ["opus"],
      onstop: () => {
        this.options?.afterStop?.();
      },
      onpause: () => {
        this.options?.afterStop?.();
      },
      onend: () => {
        this.options?.afterStop?.();
      },
      onplay: () => {
        this.options?.afterPlay?.();
      },
      onload: () => {
        this.play();
      }
    });
  }

  init() {
    this.voiceAmr = new BenzAMRRecorder();
    this.voiceAmr.initWithUrl(this.url).then(() => {
      this.play();
    });
    this.voiceAmr?.onPlay(() => {
      this.options?.afterPlay?.();
    });
    this.voiceAmr?.onStop(() => {
      this.options?.afterStop?.();
    });
  }

  isPlaying() {
    if (this.type === "opus") {
      return this.howler?.playing();
    } else {
      return this.voiceAmr?.isPlaying();
    }
  }

  play() {
    this.options?.beforePlay?.();
    if (this.type === "opus") {
      this.howler?.play();
    } else {
      this.voiceAmr?.play();
    }
    // this.options?.afterPlay?.();
  }
  stop() {
    this.options?.beforeStop?.();
    if (this.type === "opus") {
      this.howler?.stop();
    } else {
      this.voiceAmr?.stop();
    }
  }
  destroy() {
    this.options?.beforeDestroy?.();
    this.stop();
    if (this.type === "opus") {
      this.howler = null;
    } else {
      this.voiceAmr = null;
    }

    voiceHandler = null;
    this.options?.afterDestroy?.();
  }
}

function getCurVoiceHandler(id?: string, url?: string, options?: any) {
  if (!id || !url) {
    return voiceHandler;
  }
  if (voiceHandler) {
    // console.log(1);
    if (voiceHandler.id !== id) {
      // console.log(2);
      voiceHandler.stop();
      voiceHandler = new VoiceHandler(id, url, options);
      return voiceHandler;
    }
    if (voiceHandler.isPlaying()) {
      // console.log('停止播放');
      voiceHandler.stop();
    } else {
      // console.log('开始播放');
      voiceHandler.play();
    }
    return voiceHandler;
  } else {
    // console.log(3);
    voiceHandler = new VoiceHandler(id, url, options);
    return voiceHandler;
  }
}

export default getCurVoiceHandler;
